import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//PRE_QUALIFICATION_ACCEPT_DECLINED_URL
function PreQualificationAcceptDeclinedPage() {
    return (_jsx("div", { className: "declined-container", children: _jsxs("div", { className: "content", children: [_jsx("h1", { className: "first-title", children: "Credit Application" }), _jsx("p", { className: "first-subtitle", children: "Thank you for your interest." }), _jsx("p", { children: "We were unable to prequalify you." })] }) }));
}
export default PreQualificationAcceptDeclinedPage;
